"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.variants = exports["default"] = void 0;
var _merge = _interopRequireDefault(require("lodash/merge"));
var _theme = _interopRequireDefault(require("@chakra-ui/theme"));
var baseStyle = {
  transition: "all 0.15s ease",
  color: 'text.link.light',
  fontWeight: 'semibold',
  _hover: {
    color: 'primary.600',
    textDecoration: 'none'
  },
  _focus: {
    boxShadow: 'outline'
  },
  '& svg': {
    d: 'inline-block',
    verticalAlign: 'initial'
  }
};
var linkOnDark = {
  color: 'text.link.dark',
  _hover: {
    color: 'text.link.dark',
    opacity: '.8'
  }
};
var variants = exports.variants = {
  standard: baseStyle,
  onDark: linkOnDark
};
var defaultProps = {
  variant: 'standard'
};
var _default = exports["default"] = (0, _merge["default"])(_theme["default"].components.Link, {
  baseStyle: baseStyle,
  variants: variants,
  defaultProps: defaultProps
});